import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'kiene-ticket-uebersicht',
    templateUrl: './ticket-uebersicht.component.html',
    styleUrls: ['./ticket-uebersicht.component.scss'],
})
export class TicketUebersichtComponent implements OnInit {
    isPhitoadmin: boolean;

    watchClientSubscription: Subscription;

    currentClient: Client;

    constructor(private localStorageService: LocalStorageService) {}

    ngOnInit(): void {
        this.localStorageService.setShoppingCartVisible(false, 'TicketUebersichtComponent');
        this.currentClient = this.localStorageService.getCurrentClient();
        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe((client: Client) => {
            this.currentClient = client;
        });
        this.isPhitoadmin = this.localStorageService.isCurrentUserPhitoUser();
    }

    ngOnDestroy() {
        this.watchClientSubscription.unsubscribe();
    }

    isTabMenuVisible(path: string) {
        return this.localStorageService.currentUserCanSeeTab(path);
    }
}
